import type { JSX } from "react";

export type BookingStatus = "CREATED" | "PENDING_PAYMENT" | "CONFIRMED" | "USED" | "CANCELLED";
export type ServiceStatus = "DRAFT" | "PUBLISHED" | "ARCHIVED";

const BOOKING: Record<BookingStatus, { label: string; className: string }> = {
  CREATED: { label: "Created", className: "st-created" },
  PENDING_PAYMENT: { label: "Pending", className: "st-pending" },
  CONFIRMED: { label: "Confirmed", className: "st-confirmed" },
  USED: { label: "Used", className: "st-used" },
  CANCELLED: { label: "Cancelled", className: "st-cancelled" },
};

const SERVICE: Record<ServiceStatus, { label: string; className: string }> = {
  DRAFT: { label: "Draft", className: "st-draft" },
  PUBLISHED: { label: "Published", className: "st-published" },
  ARCHIVED: { label: "Archived", className: "st-archived" },
};

/**
 * Statuspille. Immer Monospace, Punkt und Großbuchstaben-Label — nie nur Farbe
 * (StyleGuide 2.5). Dieselbe Komponente erscheint in Kunden-App, Ticket und
 * Backoffice-Tabelle.
 */
export function BookingStatusPill({ status }: { status: BookingStatus }): JSX.Element {
  const meta = BOOKING[status];
  return <span className={`st ${meta.className}`}>{meta.label}</span>;
}

export function ServiceStatusPill({ status }: { status: ServiceStatus }): JSX.Element {
  const meta = SERVICE[status];
  return <span className={`st ${meta.className}`}>{meta.label}</span>;
}
